/**
 * @deprecated DO NOT USE! This is a temporary color palette for the wireframe.
 * Please use the new color palette defined in the `color.ts` file.
 */
export const oldColors = {
    primary: {
        /** #fdf8f6 */
        50: '#fdf8f6',
        /** #f2e8e5 */
        100: '#f2e8e5',
        /** #eaddd7 */
        200: '#eaddd7',
        /** #d6c4b8 */
        300: '#d6c4b8',
        /** #b8977a */
        400: '#b8977a',
        /** #9a6d4a */
        500: '#9a6d4a',
        /** #7d5436 */
        600: '#7d5436',
        /** #503216 */
        700: '#503216',
        /** #3d250f */
        800: '#3d250f',
        /** #2a1a0a */
        900: '#2a1a0a',
    },
    neutral: {
        0: 'rgba(255, 255, 255, 1)',
        /** #fafafa */
        50: '#fafafa',
        /** #f5f5f5 */
        100: '#f5f5f5',
        /** #e5e5e5 */
        200: '#e5e5e5',
        /** #d4d4d4 */
        300: '#d4d4d4',
        /** #a3a3a3 */
        400: '#a3a3a3',
        /** #737373 */
        500: '#737373',
        /** #525252 */
        600: '#525252',
        /** #404040 */
        700: '#404040',
        /** #262626 */
        800: '#262626',
        /** #171717 */
        900: '#171717',
    },
    success: {
        /** #f0fdf4 */
        50: '#f0fdf4',
        /** #dcfce7 */
        100: '#dcfce7',
        /** #22c55e */
        500: '#22c55e',
        /** #16a34a */
        600: '#16a34a',
        /** #15803d */
        700: '#15803d',
    },
    warning: {
        /** #fffbeb */
        50: '#fffbeb',
        /** #fef3c7 */
        100: '#fef3c7',
        /** #f59e0b */
        500: '#f59e0b',
        /** #d97706 */
        600: '#d97706',
        /** #b45309 */
        700: '#b45309',
    },
    error: {
        /** #fef2f2 */
        50: '#fef2f2',
        /** #fee2e2 */
        100: '#fee2e2',
        /** #ef4444 */
        500: '#ef4444',
        /** #dc2626 */
        600: '#dc2626',
        /** #b91c1c */
        700: '#b91c1c',
    },
    info: {
        /** #eff6ff */
        50: '#eff6ff',
        /** #dbeafe */
        100: '#dbeafe',
        /** #3b82f6 */
        500: '#3b82f6',
        /** #2563eb */
        600: '#2563eb',
        /** #1d4ed8 */
        700: '#1d4ed8',
    },
};
